import React from 'react';
import { useResponsiveRender } from 'hooks/useResponsiveRender';
import { ChevronDown20 } from '@carbon/icons-react';
import ItemMenu from '../ItemMenu/ItemMenu';
import { useToggle } from 'hooks/useToggle';
import { useClickOutside } from 'hooks/useClickOutside';
import { useOnChangeLocation } from 'hooks/useOnChangeLocations';
// styles
import styles from './no-logged-navigation.module.scss';

const NoLoggedNavigation = ({ routesNav }) => {
  const { renderMobile: renderDesk } = useResponsiveRender({ breakpoint: 950 });
  const { renderMobile } = useResponsiveRender({ breakpoint: 767 });

  const isDeskLarge = !renderDesk ? undefined : 1;

  const [showMoreMenu, onToggleMoreMenu, onCloseMenu] = useToggle(false);

  const domRef = useClickOutside(() => {
    if (showMoreMenu) onToggleMoreMenu();
  });

  useOnChangeLocation(() => onCloseMenu());

  if (renderMobile) {
    return null;
  }

  return (
    <nav className={`${styles.no_logged_navigation} menu`} aria-labelledby="HeaderMenu">
      <div className={styles.nav}>
        {routesNav.slice(0, isDeskLarge).map((route, index) => (
          <ItemMenu className={styles.item_desktop} {...route} key={index} />
        ))}

        {renderDesk && (
          <div className={`${styles.more_menu} cursor-pointer`} onClick={onToggleMoreMenu} ref={domRef}>
            <div className={styles.more_item}>
              More <ChevronDown20 />
            </div>
            {showMoreMenu && (
              <div className={styles.more_menu_container}>
                {routesNav.slice(1).map((route, index) => (
                  <ItemMenu className={styles.item_desktop} {...route} key={index} />
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default NoLoggedNavigation;
